/*eslint-disable */

import axios from 'axios';
import batchPatient from './batch-patients-data-use/';
import {
mapGetters,
} from 'vuex';
import modelPredicationRightSidebar from '@/components/private/ai-dashboard/model-predication-right-sidebar/';
import singlePatient from './signle-patient-data-use/';

export default {
  name: 'new-model-use',
  components: {
    'single-patient' : singlePatient,
    'batch-patient' : batchPatient,
    'right-sidebar' : modelPredicationRightSidebar
  },
  props: [],
  data() {
    return {
      submitted:false,
      selectedModelId:'',
      model_name:'',
      selectedModelDetails:null,
      selection_type:'single_patient',
      isBatch:false,
      publicModelIdHardcode:''
    }
  },
  computed: {
    ...mapGetters([
      'getModelsDetailsByIdGetters'
    ]),
    getModelInfoByIdFun(){
      return this.$store.getters.getModelsDetailsByIdGetters;
    },
  },
  mounted() {
    this.publicModelIdHardcode = process.env.VUE_APP_PUBLIC_AI_MODEL_ID
    this.selectedModelId = this.$route.params.useModelsId
    this.selectedModelDetails = this.$store.getters.getModelsDetailsByIdGetters.data; 
    if(this.selectedModelDetails){
      this.model_name = this.selectedModelDetails.name 
      this.isBatch = this.selectedModelDetails.is_batch
    }
  },
  methods: {
    nextDescribeListMethod(url){
      this.$validator.validateAll().then((result) => {
        if (result) {
          this.submitted = true
          axios.get(url).then((response) => {
              this.labelDescListNext = response.data.data.next
              this.labelDescList = [].concat(this.labelDescList, response.data.data.results);
              this.submitted = false
            });
          return;
        }
      })
    },
    selectedOptionMethod(item){
      this.selection_type = item
    }
  },
  watch:{
    getModelInfoByIdFun(newVal, oldVal){
      this.selectedModelDetails = newVal.data; 
      if(this.selectedModelDetails){
        this.model_name = this.selectedModelDetails.name 
        this.isBatch = this.selectedModelDetails.is_batch
      }
    }
  },
}